﻿module SafeStack.Client.DownloadControl

open Fable.React
open Fable.React.Props
open Illy.SafeStack.Client
open SafeStack.Client

type Loading = bool

type CustomSettings =
    {
        Properties: IHTMLProp list
        Modifiers: FontAwesome.Modifier list
    }

module CustomSettings =
    let defaultOptions() =
        {
            Properties = []
            Modifiers = []
        }

type Control =
    {
        Downloading: bool
        Label: string option
        Tooltip: string option
    }

type Model = ControlState<Control, CustomSettings>

type Event =
    | Clicked

type Msg =
    | Click

let initControl label tooltip =
    {
        Downloading = false
        Label = label
        Tooltip = tooltip
    }

let init label tooltip settings =
    {
        Control = initControl label tooltip
        Settings = ControlSettings.defaultOptions
        CustomSettings = settings
    }

let update (msg: Msg) (model: Model) : (Model * SideEffect<Msg, Event>) =
    match msg with
    | Click -> { model with Model.Control.Downloading = true }, Event.Clicked |> SideEffect.Event 

let button loading (dispatch: Msg -> unit) (model: Model) =
    if loading then
        jQueryUI.skeletonScreenIcon
    else if model.Control.Downloading then
        jQueryUI.saveSpinner
    else
        let tooltip =
            match model.Control.Tooltip with
            | Some tt -> Tooltip.create [ str tt ]
            | None -> id

        span
            [
                yield! model.CustomSettings.Properties
                yield Style [
                    Cursor <| if model.Control.Downloading then "not-allowed" else "pointer"
                ]
                yield OnClick (fun _ -> dispatch Msg.Click)
        ] [
            yield FontAwesome.solid
                    "download"
                    model.CustomSettings.Modifiers
                    [ if Option.isSome model.Control.Label then yield Style [ MarginRight "1ch" ] ]
            match model.Control.Label with
            | Some l -> yield str l
            | None -> ()
        ]
        |> tooltip

let resetDownloading model =
    { model with Model.Control.Downloading = false }